import { Link } from "react-router-dom";
import TutorAvatar from "./TutorAvatar";
import { formatCurrency } from "../lib/format";

export default function TutorCard({ tutor }) {
  const tags = (tutor.tags?.length ? tutor.tags : tutor.subjects).slice(0, 3);

  return (
    <article className="surface-panel card-lift relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-signal via-sun to-skyglow" />
      <div className="flex h-full flex-col p-6">
        <div className="flex items-start gap-4">
          <TutorAvatar
            src={tutor.image}
            name={tutor.name}
            alt={`${tutor.name} tutor portrait`}
            className="h-20 w-20 rounded-[24px]"
            textClassName="text-2xl"
          />
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap gap-2">
              <span className="chip">⭐ {tutor.rating.toFixed(1)}</span>
              <span className="chip">{formatCurrency(tutor.price)}/hr</span>
            </div>
            <h3 className="mt-3 font-display text-2xl font-extrabold text-ink">{tutor.name}</h3>
            <p className="mt-1 text-base font-semibold leading-6 text-slate-600">{tutor.headline}</p>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap gap-2">
          {tags.map((tag) => (
            <span key={tag} className="chip">
              {tag}
            </span>
          ))}
        </div>

        <p className="mt-5 flex-1 text-base leading-7 text-slate-600">{tutor.shortBio}</p>

        <div className="mt-6 flex items-center justify-between gap-3 border-t border-slate-100 pt-5">
          <div>
            <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-400">
              Verified Tutor
            </p>
            <p className="mt-1 text-sm font-semibold text-slate-600">{tutor.qualifications}</p>
          </div>
          <div className="flex gap-2">
            <Link to={`/tutor/${tutor.id}`} className="button-secondary px-5 py-2.5">
              View
            </Link>
            <Link to={`/tutor/${tutor.id}?book=1`} className="button-primary px-5 py-2.5">
              Book
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
